jQuery(document).ready(function ($) {
    'use strict';

    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        return;
    }

    /* Moins de mouvement demande : aucun etat de depart n'est pose, donc
       le bloc reste tel que le navigateur l'a rendu. */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    var blocs = document.querySelectorAll('.bloc_cartes_args');

    if (!blocs.length) {
        return;
    }

    /**
     * ROTATION DU GLOBE
     * DUREE_TOUR est le temps, en secondes, d'un tour du monde complet.
     * DEPART place une longitude au centre du disque au premier rendu,
     * exprimee en pourcentage de la largeur du planisphere : 50 conserve
     * le cadrage centre d'origine, 0 partirait sur le Pacifique.
     */
    var DUREE_TOUR = 140;
    var DEPART = 50;

    /**
     * CARTES ARGUMENTS
     * Reglages repris du bloc liens.
     */
    var DEBUT = 'top 100%';
    var FIN = 'top 50%';
    var SCRUB = 0.8;

    var DISTANCE = 180;
    var DUREE = 0.5;
    var DECALAGE = 0.15;
    var EASE = 'power2.out';

    /**
     * Le planisphere est double et defile en boucle : quand la premiere
     * copie a fini de sortir a gauche, la seconde occupe exactement sa
     * position de depart, donc la boucle se referme sans saut. L'image
     * s'y prete, ses deux bords tombent au milieu du Pacifique.
     *
     * Les styles du conteneur sont dans cartes_args.scss.
     */
    function animerGlobe(bloc) {
        var figure = bloc.querySelector('figure');
        var image = figure ? figure.querySelector('img') : null;

        if (!image) {
            return;
        }

        var panorama = document.createElement('div');

        panorama.className = 'panorama';
        figure.insertBefore(panorama, image);
        panorama.appendChild(image);

        var clone = image.cloneNode(true);

        /* La copie ne porte aucune information : elle sort du champ des
           lecteurs d'ecran. */
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('alt', '');
        panorama.appendChild(clone);

        function lancer() {
            var fenetre = figure.clientWidth;
            var largeurCarte = image.getBoundingClientRect().width;

            /* Largeur pas encore mesurable : on attend le chargement.
               hh_images pose width et height en attributs, le navigateur
               connait donc le ratio d'avance et ce cas reste rare. */
            if (largeurCarte <= 0) {
                image.addEventListener('load', lancer, {once: true});
                return;
            }

            /* Decalage initial amenant la longitude DEPART au centre du
               disque, exprime en pourcentage du panorama. Stable au
               redimensionnement : le rapport entre le disque et le
               planisphere ne depend que de leurs deux ratios, tous deux
               fixes. */
            var centrage = (fenetre / 2 - (DEPART / 100) * largeurCarte) / (largeurCarte * 2) * 100;

            var rotation = gsap.fromTo(panorama,
                {xPercent: centrage},
                {
                    xPercent: centrage - 50,
                    duration: DUREE_TOUR,
                    ease: 'none',
                    repeat: -1
                }
            );

            /* Une boucle infinie qui tourne dans un bloc sorti de l'ecran
               consomme du GPU pour rien, et cela se sent sur un portable. */
            ScrollTrigger.create({
                trigger: bloc,
                start: 'top bottom',
                end: 'bottom top',
                onToggle: function (self) {
                    if (self.isActive) {
                        rotation.play();
                    } else {
                        rotation.pause();
                    }
                }
            });
        }

        lancer();
    }

    /**
     * Montee des cartes au scroll, comme sur le bloc liens.
     *
     * Le declencheur est la grille et non le bloc entier : ce bloc est
     * beaucoup plus haut que celui des liens a cause du globe, et un
     * declenchement sur son sommet aurait fait monter les cartes bien
     * avant qu'elles arrivent a l'ecran.
     */
    function animerCartes(bloc) {
        var grille = bloc.querySelector('.arguments');
        var cartes = grille ? grille.querySelectorAll('.arg') : [];

        if (!cartes.length) {
            return;
        }

        gsap.set(cartes, {y: DISTANCE});

        gsap.to(cartes, {
            y: 0,
            duration: DUREE,
            stagger: DECALAGE,
            ease: EASE,
            scrollTrigger: {
                trigger: grille,
                start: DEBUT,
                end: FIN,
                scrub: SCRUB
            }
        });
    }

    Array.prototype.forEach.call(blocs, function (bloc) {
        animerGlobe(bloc);
        animerCartes(bloc);
    });
});
